
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, BookOpen, FileText } from "lucide-react";
import { resourceItems } from "../navData";

const MobileResourcesSection = ({ onClose }: { onClose: () => void }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between py-3 border-b w-full text-left"
      >
        <div className="flex items-center">
          <BookOpen className="h-5 w-5 text-grandpal-green mr-3" />
          <h3 className="font-medium text-gray-800 font-lora">Resources</h3>
        </div>
        <ChevronDown 
          className={`h-5 w-5 text-grandpal-green transition-transform duration-200 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
        />
      </button>
      {isOpen && (
        <div className="py-4 pl-4 space-y-3 animate-fade-in">
          <h4 className="text-xs uppercase tracking-wide text-grandpal-green font-medium mb-2">Decision Support Tools</h4>
          {resourceItems.map((item) => (
            <div key={item.title} className="flex items-start py-2">
              <div className="mr-3 mt-0.5 bg-grandpal-green-light p-2 rounded-md text-grandpal-green">
                {item.icon}
              </div>
              <div>
                <Link
                  to={item.path}
                  className="block font-medium text-gray-700 hover:text-grandpal-green transition-colors"
                  onClick={onClose}
                >
                  {item.title}
                </Link>
                <p className="text-sm text-grandpal-gray mt-1">{item.description}</p>
              </div>
            </div>
          ))}
          <Link
            to="/calculator"
            className="flex items-center gap-2 py-1.5 text-gray-700 hover:text-grandpal-green transition-colors"
            onClick={onClose}
          >
            <FileText className="h-4 w-4 text-grandpal-green" />
            <span>Cost Estimator</span>
          </Link>
        </div>
      )}
    </div>
  );
};

export default MobileResourcesSection;
